// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online Ultimate',
  freeTimesLimitTitle: "La prova per l'account gratuito si esaurisce oggi.",
  fileSizeLimitTitle:
    "La dimensione del file per l'account gratuito non può superare i 20 MB.",
  freeImgCutoutTimesLimitTitle:
    "L'opportunità di prova di oggi per la rimozione in background è stata esaurita, esegui l'upgrade a Pro per accedere a tutte le funzionalità premium",
  total: 'Totale',
  enterCode: 'Inserisci il codice',
  signUpToPurchaseBtn: 'Registra per acquistare',
  goPurchseBtn: "Vai all'acquisto",
  saveTips: 'Risparmia fino al {{num}}%',
  discount: 'Sconto',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYear: '3,75€',
  billedMonth: '29,99€ Pagato Mensilmente',
  billedYear: '179,99€ Pagato Annualmente',
  monthly: 'Mensile',
  yearly: 'Annuale',
  weekly: 'settimanalmente',
  week: 'Settimana',
  AlreadySubscribe: 'Già iscritto?',
  vipTips1: 'Nessun limite di dimensione dei file',
  vipTips2: 'Elaborazione di quantità di file senza limiti',
  vipTips3: 'Modificare gli sfondi delle immagini senza limiti',
  vipTips4: 'Accesso a tutti gli strumenti gratuiti e alle funzioni premium',
  purchaseTips: 'Rinnova automaticamente e annulla in qualsiasi momento.',
  tips: 'Suggerimenti:',
  promoCodeInvalidTips: 'Il tuo codice promozionale non è valido',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
